exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-component[data-v-0c4c879a] {\n  position: relative;\n}\n.search-component .results[data-v-0c4c879a] {\n  position: absolute;\n  width: calc(100% - 10px);\n  background: rgba(255, 255, 255, 0.91);\n  margin: 5px;\n  max-height: 300px;\n  overflow: auto;\n}\n", ""]);

// exports
